import type { ImmunizationModel } from '@ctw/shared/api/fhir/models/immunization';
import { ContentCard } from '@ctw/shared/components/containers/content-card';
import { DefinitionList } from '@ctw/shared/components/definition-list';
import { ResponsiveSourceDocumentLink } from '@ctw/shared/content/CCDA/responsive-source-document-link';
import type { UseResourceDrawerOpenDrawerArgs } from '@ctw/shared/context/resource-drawer-context';
import { entryFromArray } from '@ctw/shared/utils/entry-from-array';

export const immunizationDrawerAction: UseResourceDrawerOpenDrawerArgs<'Immunization'>['action'] =
  ({ model, requestContext }) => ({
    label: 'Immunization',
    title: model.title,
    content: {
      body: (
        <ContentCard
          variant="focal"
          title="Details"
          content={{
            header: <ResponsiveSourceDocumentLink model={model} />,
          }}
        >
          <DefinitionList items={immunizationData(model, requestContext.builderId)} />
        </ContentCard>
      ),
    },
  });

const immunizationData = (immunization: ImmunizationModel, builderId: string) => [
  { label: 'Date Given', value: immunization.occurrence },
  { label: 'Recorded By', value: immunization.managingOrganization },
  { label: 'Status', value: immunization.status },
  { label: 'Dose Quantity', value: immunization.doseQuantity },
  { label: 'Route', value: immunization.route },
  { label: 'Site', value: immunization.site },
  { label: 'Lot Number', value: immunization.resource.lotNumber },
  ...entryFromArray('Note', immunization.notesDisplay),
  { label: 'Data Source', value: immunization.getDataSourceDisplay(builderId) },
];
